export default {
  'radius-100': '0.25rem',
  'radius-200': '0.5rem',
  'radius-full': '50%'
};
